/**
 * IA Benefits with Media Web Component
 * Handles dynamic tab switching by swapping contents in slots from templates.
 */
if (!customElements.get('ia-benefits-with-media')) {
  class IaBenefitsWithMedia extends HTMLElement {
    constructor() {
      super();
      this.slots = {
        media: this.querySelector('[data-benefits-slot="media"]'),
        aboveTitle: this.querySelector('[data-benefits-slot="above-title"]'),
        belowContent: this.querySelector('[data-benefits-slot="below-content"]')
      };
      this.tabs = this.querySelectorAll('[data-benefits-tab]');
      this.templates = this.querySelectorAll('[data-benefits-template]');

      this.init();
    }

    init() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = tab.dataset.benefitsTab;
          this.switchTab(index);
        });
      });
    }

    switchTab(index) {
      // Update active state on tab buttons
      this.tabs.forEach(t => {
        const isActive = t.dataset.benefitsTab === index;
        t.classList.toggle('ia-tab--active', isActive);
        t.classList.toggle('is-active', isActive);
      });

      // Find the template for the selected tab
      const template = Array.from(this.templates).find(temp => temp.dataset.benefitsTemplate === index);
      if (!template) return;

      // Clone the template content
      const content = template.content;

      // Swap contents for each slot
      this.updateSlot('media', content);
      this.updateSlot('above-title', content);
      this.updateSlot('below-content', content);
    }

    /**
     * Updates a specific slot with content from the template's corresponding part
     * @param {string} slotName - The name of the slot to update
     * @param {DocumentFragment} templateContent - The cloned content from the template
     */
    updateSlot(slotName, templateContent) {
      const slotElement = this.querySelector(`[data-benefits-slot="${slotName}"]`);
      const partElement = templateContent.querySelector(`[data-template-part="${slotName}"]`);

      if (slotElement && partElement) {
        slotElement.innerHTML = partElement.innerHTML;
      }
    }
  }

  customElements.define('ia-benefits-with-media', IaBenefitsWithMedia);
}
